/**
 * PWA Logo Validator
 * Ensures that PWA logo is the specified logo: Logo.png
 */

const VALID_PWA_LOGOS = ['Logo.png'];

/**
 * Validates if a logo path is one of the allowed PWA logos
 * @param {string} logoPath - The path to the logo file
 * @returns {boolean} - True if logo is valid, false otherwise
 */
export function isValidPWALogo(logoPath) {
  if (!logoPath) return false;

  const fileName = logoPath.split('/').pop().split('?')[0]; // Remove path and query params
  return VALID_PWA_LOGOS.includes(fileName);
}

/**
 * Gets the default PWA logo (Logo.png — navy bg baked in for installable icons)
 * @returns {string} - Path to default logo
 */
export function getDefaultPWALogo() {
  return '/Logo.png';
}

/**
 * Gets the alternative PWA logo (transparent Logo.png — for in-app contexts)
 * @returns {string} - Path to alternative logo
 */
export function getAlternativePWALogo() {
  return '/Logo.png';
}

/**
 * Validates manifest.json icons to ensure they use valid logos
 * @param {Array} icons - Array of icon objects from manifest
 * @returns {Object} - { valid: boolean, invalidIcons: Array }
 */
export function validateManifestIcons(icons) {
  if (!Array.isArray(icons)) {
    return { valid: false, invalidIcons: [], error: 'Icons must be an array' };
  }

  const invalidIcons = icons.filter(icon => !isValidPWALogo(icon.src));

  return {
    valid: invalidIcons.length === 0,
    invalidIcons,
    validIcons: icons.filter(icon => isValidPWALogo(icon.src))
  };
}

export { VALID_PWA_LOGOS };
